import { Component } from '@angular/core';

import { NceService } from '../services/nce.service';

import { StorageService } from '../../shared/services/storage.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { ErrorService } from '../../shared/services/error.service';
import { STATIC_VALUE } from '../../shared/configuration/static.value';
import { FileService } from './../../shared/services/file.service';

@Component({
    selector: 'nce-fill-in-particulars',
    templateUrl: 'fill-in-particulars.component.html'
})
export class NceFillInParticularsComponent{

    vTempPlantID: string;
    vTempPlantPIN: string;
    vContractPrincipal:string;
    vMinContractDate = new Date();

    constructor(
        private _nceService: NceService,
        private _layoutService: LayoutService, 
        private _pageNavigationService: PageNavigationService,
        private _storageService: StorageService,
        private _errorService: ErrorService,
        private _fileService: FileService,
    ) {
        
    }

    ngOnInit() {
    	this._layoutService.setCurrentPage('nce-fill-in-particulars');

        this._nceService.resetNCEData();
        this._nceService.resetFillInParticulars();
        this._nceService.resetError();

        this._storageService.setSessionItem('extensionNCE', '0');
        this.vTempPlantID = this.getFillInParticulars().plant_request_id;
        
        this.vMinContractDate = new Date(this.getFillInParticulars().contract_start);
        this.vMinContractDate.setDate(this.vMinContractDate.getDate() + 1);
    }

    getFillInParticulars(){
        return this._nceService.getFillInParticulars();
    }
    
    getErrorStatusAndMessage(){
        return this._errorService.getErrorStatusAndMessage();
    }

    isDisableSubmit(){
        return this._nceService.isDisableSaveFillInParticular();
    }

    isLoading(){
        return this._nceService.isLoading();
    }

    getPrincipalsValue(){
        return STATIC_VALUE.NCE_CONTRACT_PRINCIPALS;
    }

    setMinContractEnd(pSelectedDate){
        this.vMinContractDate = new Date(pSelectedDate);
        this.vMinContractDate.setDate(this.vMinContractDate.getDate() + 1);
        let vContractEnd = new Date(this.getFillInParticulars().contract_end);
        if(pSelectedDate.getTime() >= vContractEnd.getTime()){
            this.getFillInParticulars().contract_end = '';
        }
    }

    checkPlantID(){
        this.vTempPlantID = this.vTempPlantID.toUpperCase().trim();
        this.vTempPlantPIN = this.vTempPlantPIN ? this.vTempPlantPIN.toString().trim() : '';
        this._nceService.checkPlantRequestID(this.vTempPlantID, this.vTempPlantPIN);
    }

    vContractPrincipalChange() {
        console.log(this.vContractPrincipal, this.getFillInParticulars().contract_principal);
        if(this.vContractPrincipal !== 'Other Agencies & Pte'){
            this.getFillInParticulars().contract_principal = this.vContractPrincipal;
        } else {
            this.getFillInParticulars().contract_principal = '';
        }
    }

    submitFillInParticulars(){
        this._nceService.saveFillInParticulars();
    }

    goBack(){
        let vLink = ['home'];
        this._pageNavigationService.navigate(vLink);
    }

    // downloadEarthworksRequirements() {        
    //     this._fileService.getMiscSignedDownloadRequest('Appendix A_Earthworks Requirements.pdf');
    // }

    /*isInputShow() {
        if((this.isExtensionNCE === '1' && this.getFillInParticulars().nce_record_id !== '') || this.isExtensionNCE === '0' && this.getFillInParticulars().plant_record_id !== '') {
            return true;
        } else {
            return false;
        }
    }*/

    isInputShow() {
        return this.getFillInParticulars().plant_record_id !== '';
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce/components/fill-in-particulars.component.ts